import axios from "@/axios";
import { AxiosResponse } from "axios";
import {
  SaveReportRequest,
  DomainResponse,
  FieldDataResponse,
  LabDataResponse,
  FieldDataTransitionsResponse,
  GetDomainsResponse,
  AddCwvDomainBody,
  GetDomainResponse,
  UpdateCwvDomainBody,
} from "@/features/coreWebVitals/types";
import qs from "qs";

export function getDomainForCwv(publisherId: number): Promise<AxiosResponse<DomainResponse>> {
  return axios.get<DomainResponse>(`/publishers/${publisherId}/domains/cwv/`);
}

export function getFieldData(domainId: number | null): Promise<AxiosResponse<FieldDataResponse>> {
  return axios.get<FieldDataResponse>(`/cwv/field-data/${domainId}/`);
}

export function getLabData(domainId: number | null): Promise<AxiosResponse<LabDataResponse>> {
  return axios.get<LabDataResponse>(`/cwv/lab-data/${domainId}/`);
}

export function getFieldDataTransitions(
  period: string,
  domainId: number | null
): Promise<AxiosResponse<FieldDataTransitionsResponse>> {
  return axios.get<FieldDataTransitionsResponse>(`/cwv/field-data-transitions/${domainId}/`, {
    params: {
      period: period,
    },
  });
}

// TODO: リクエスト・レスポンス確定し次第 interface 化
export function saveReport(data: SaveReportRequest): Promise<AxiosResponse<{ reportId: number }>> {
  return axios.post<{ reportId: number }>(`/cwv/reports/`, data);
}

export function generateReport(reportId: number | null): Promise<AxiosResponse<{ jobId: string }>> {
  return axios.post<{ jobId: string }>(`/cwv/reports/${reportId}/`);
}

export function getReportUrl(jobId: string | null): Promise<AxiosResponse<{ report_url: string }>> {
  return axios.get<{ report_url: string }>(`/cwv/reports/file/${jobId}/`);
}

export function getVisibleCwvDomains(
  publisher: number[]
): Promise<AxiosResponse<GetDomainsResponse>> {
  return axios.get<GetDomainsResponse>(`/cwv/domains/`, {
    params: {
      publisher: publisher,
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" }),
  });
}

export function addCwvDomain(data: AddCwvDomainBody): Promise<AxiosResponse<void>> {
  return axios.post(`/cwv/domains/`, data);
}

export function getCwvDomainInfo(domainId: number): Promise<AxiosResponse<GetDomainResponse>> {
  return axios.get<GetDomainResponse>(`/cwv/domains/${domainId}/`);
}

export function updateCwvDomain(
  data: UpdateCwvDomainBody,
  domainId: number
): Promise<AxiosResponse<void>> {
  return axios.put(`/cwv/domains/${domainId}/`, data);
}

export function deleteCwvDomain(domainId: number | undefined): Promise<AxiosResponse<void>> {
  return axios.delete(`/cwv/domains/${domainId}/`);
}
